import getStratBussiMatrix from "@custom/rtk-apis/analytics/getStratBussiMetrix";
import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  status:"",
  result:null,
  msg:"",
  loading:false,
  error:""
};

const getStratBussiMetrixSlice = createSlice({
  name: "getStratBussiMetrixSlice",
  initialState,
  reducers: {
    clearStratBussiMetrix: state => {
      state.status = '';
      state.result = '';
      state.msg = '';
      state.loading = false;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(getStratBussiMatrix.pending, (state, action) => {
        state.loading = true;
      })
      .addCase(getStratBussiMatrix.fulfilled, (state, { payload }) => {
        state.loading = false;
        state.status = "SUCCESS";
        state.result = payload;
        state.msg = payload.msg;
      })
      .addCase(getStratBussiMatrix.rejected, (state, { payload }) => {
        state.result = payload;
        state.loading = false;
      });
  },
});

export default getStratBussiMetrixSlice.reducer;
export const { clearStratBussiMetrix } = getStratBussiMetrixSlice.actions;
